import type { TeamPublic } from '../types/arena';
import { formatFaClock, formatFaNumber } from './format';

const safeNumber = (value: unknown, fallback = 0) => (typeof value === 'number' && Number.isFinite(value) ? value : fallback);

export function averageAnswerMs(team: TeamPublic): number {
  const submitted = Math.max(1, safeNumber(team.submittedCount, team.correctCount || 1));
  return safeNumber(team.totalAnswerMs) / submitted;
}

export function formatDuration(ms: number | null | undefined): string {
  if (typeof ms !== 'number' || !Number.isFinite(ms) || ms <= 0) return '—';
  if (ms < 1000) return `${formatFaNumber(Math.round(ms))} ms`;
  const seconds = ms / 1000;
  if (seconds < 60) return `${seconds.toLocaleString('fa-IR', { maximumFractionDigits: 1 })} ثانیه`;
  return formatFaClock(ms);
}

export function teamPerformanceLabel(team: TeamPublic): string {
  const submitted = safeNumber(team.submittedCount, team.correctCount);
  const correct = safeNumber(team.correctCount);
  if (!submitted) return 'بدون تلاش ثبت‌شده';
  const avgAnswer = averageAnswerMs(team);
  const accuracy = correct / Math.max(1, submitted);

  if (!correct) return 'نیازمند مرور';
  if (accuracy < 0.5) return 'در حال یادگیری';
  if (avgAnswer <= 45_000) return 'برق‌آسا';
  if (safeNumber(team.bestStreak) >= 5) return 'زنجیره‌ساز';
  if (accuracy >= 0.8) return 'دقیق و کم‌خطا';
  if (safeNumber(team.hardCorrect) >= 2) return 'سخت‌کُش';
  return 'جنگنده میدان';
}
